import React, { useState, useEffect } from 'react';

import Constant from '@/common/constant/Constant';

import {
    IconButton,
    Button,
    Popover,
    TextField
} from '@material-ui/core';

import {
    isAddNewItem,
    onCancelSaveItemList,
    onChangeCustomerView,
    onChangeItemName,
    onKeyPressItemName,
    onSubmitSaveItemList,
    removeItem,
    reOrderItemList,
    selectItemColor,
    sortStatusItemListByStructure
} from '@/component/formManagement/handler/FieldStatusItemHandler';
import { closePanelFormManagement, generateItemFieldStatus, isEditField } from '../handler/CommonHandler';

import Utils from '@/common/utils/utils';
import itemStatusColor from '@/common/constant/ItemStatusColor';
import { useRecoilState } from 'recoil';
import { multiPanelAtom, panelSettingAtom, panelStartIndexAtom } from '@/state/atom/panelAtom';
import { validateItemListFieldStatus } from '@/component/formManagement/handler/FieldListHandler';
import _ from 'lodash';
import { getItemFieldListByFieldId } from '@/service/formManagementService';
import UnsavedChangesDialog from '../UnsavedChangesDialog';
import { formPanelTabCloseManagementAtom } from '@/state/atom/formAtom';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function AddFieldStatusItem(props) {
    // Subscribe to translation updates so displayed labels re-render on language change
    useTranslationSubscription();
    const [settingSlideRecoilState, setSettingSlideRecoilState] = useRecoilState(panelSettingAtom);
    // list using
    const [itemUsingList, setItemUsingList] = useState([]);
    const [itemNotUsingList, setItemNotUsingList] = useState([]);
    const [isDeleteItem, setIsDeleteItem] = useState(false);

    // Popover change item name
    const [nameStylePopover, setNameStylePopover] = useState(null);
    const isOpenNameStylePopover = Boolean(nameStylePopover);
    const idNameStyle = isOpenNameStylePopover ? 'change-name-style' : '';

    // Popover change item customer name
    const [customerNameStylePopover, setCustomerNameStylePopover] = useState(null);
    const isOpenCustomerNameStylePopover = Boolean(customerNameStylePopover);
    const idCustomerNameStyle = isOpenCustomerNameStylePopover ? 'change-customer-name-style' : '';

    // Current update field
    let currentField = props.currentUpdateField;

    // List item status in field
    const [itemList, setItemList] = useState([]);
    const [updateStyleIndex, setUpdateStyleIndex] = useState(-1);

    // Backup item list
    const [itemListDefault, setItemListDefault] = useState([]);

    const [createdItemList, setCreatedItemList] = useState([]);
    const [isDisableBtnSave, setIsDisableBtnSave] = useState(true);

    // manager edited state form, field screen, close panel atom 
    const [formPanelTabClose, setFormPanelTabClose] = useRecoilState(formPanelTabCloseManagementAtom);

    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const [currentIndex, setCurrentIndex] = useRecoilState(panelStartIndexAtom);

    const argsAll = {
        currentField,
        itemList,
        setItemList,
        itemUsingList,
        setItemUsingList,
        itemNotUsingList,
        setItemNotUsingList,
        updateStyleIndex,
        setUpdateStyleIndex,
        itemListDefault,
        setItemListDefault,
        createdItemList,
        setCreatedItemList,
        isDisableBtnSave,
        setNameStylePopover,
        setCustomerNameStylePopover,
        settingSlideRecoilState,
        setSettingSlideRecoilState,
        setIsDeleteItem,
        setIsDisableBtnSave,
        setFormPanelTabClose  // Add for 閉じる button handler
    };

    const [useButtonCollapse, setUseButtonCollapse] = useState(true);
    const [unUseButtonCollapse, setUnUseButtonCollapse] = useState(true);

    const hanldeUseButtonCollapse = () => {
        if (useButtonCollapse === true) {
            setUseButtonCollapse(false);
        } else {
            setUseButtonCollapse(true);
        }
    };

    const hanldeUnUseButtonCollapse = () => {
        if (unUseButtonCollapse === true) {
            setUnUseButtonCollapse(false);
        } else {
            setUnUseButtonCollapse(true);
        }
    };

    useEffect(() => {
        getItemFieldListByFieldId(
            props?.API,
            Constant.FORM_USAGE.STATUS,
            props.currentUpdateField.affiliationOrganization,
            props.currentUpdateField.id
        ).then(listFieldItemRecord => {
            let itemListOfStatusField = [];
            if (!Utils.isEmptyArray(listFieldItemRecord)) {
                listFieldItemRecord = sortStatusItemListByStructure(listFieldItemRecord);
                listFieldItemRecord?.forEach(item => {
                    itemListOfStatusField.push(generateItemFieldStatus(item));
                });
                itemListOfStatusField = sortStatusItemListByStructure(itemListOfStatusField);
            }
            setItemList(itemListOfStatusField);
            setItemListDefault(itemListOfStatusField);
            setCreatedItemList(listFieldItemRecord);
        });
    }, [props.currentUpdateField]);

    useEffect(() => {
        let itemUsingListForUpdate = [];
        let itemNotUsingListForUpdateForUpdate = [];

        itemList?.forEach(item => {
            if (item.structure.isUsingItem) {
                itemUsingListForUpdate.push(item);
            } else {
                itemNotUsingListForUpdateForUpdate.push(item);
            }
        });

        itemUsingListForUpdate = reOrderItemList(itemUsingListForUpdate);

        // sort itemNotUsingList by abc
        itemNotUsingListForUpdateForUpdate.sort((item1, item2) => {
            let name1 = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, item1.name);
            let name2 = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, item2.name);
            return name1.localeCompare(name2);
        });

        // update state
        setItemUsingList(itemUsingListForUpdate);
        setItemNotUsingList(itemNotUsingListForUpdateForUpdate);
    }, [itemList]);

    // check disable btn save
    useEffect(() => {
        let validateResult = validateItemListFieldStatus(itemList);
        if (!validateResult.status) {
            setIsDisableBtnSave(true);
            return;
        }

        if (itemList.length !== itemListDefault.length) {
            setIsDisableBtnSave(false);
            return;
        }

        if (isDeleteItem) {
            setIsDisableBtnSave(false);
            return;
        }

        let isDisable = true;

        for (const item of itemList) {
            let indexExist = Utils.findIndexInArrayById(item.id, itemListDefault);
            if (indexExist === -1) {
                isDisable = false;
            } else {
                let itemDefault = itemListDefault[indexExist];
                isDisable =
                    (Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, item.name) ===
                        Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, itemDefault.name) && //compare name
                    Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, item.viewForCustomer) ===
                        Utils.getTextByLanguage(
                            Constant.LANGUAGE_TYPE.JP,
                            itemDefault.viewForCustomer
                        ) && //compare customer name
                    item.structure.no === itemDefault.structure.no && // compare number
                    item.structure.isUsingItem === itemDefault.structure.isUsingItem && // compare isUsingItem
                    _.isEqual(item.structure.helpdesk, itemDefault.structure.helpdesk) && // compare helpdesk data
                        _.isEqual(item.structure.customer, itemDefault.structure.customer)) || // compare helpdesk data
                    Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, item.viewForCustomer)
                        .length > 20; // customer status length ? 20
            }

            // if isDisable false then break
            if (!isDisable) {
                break;
            }
        }

        setIsDisableBtnSave(isDisable);
    }, [itemList]);

    // uef listen change data from AddFieldStatusItem Screen
    useEffect(() => {
        if (!isDisableBtnSave) {
            setFormPanelTabClose(prev => ({...prev, isDirty: true}));
        }
    }, [isDisableBtnSave]);


    // renderColorPicker
    const renderColorPicker = type => {
        return (
            <div className="status-item-color-picker" data-cy="add-status-field-picker-color">
                {itemStatusColor.map(itemColor => (
                    <span
                        key={`${itemColor.id}`}
                        style={{
                            color: `${itemColor.color}`,
                            background: `${itemColor.background}`
                        }}
                        onClick={e => selectItemColor(type, itemColor, argsAll)}
                    >
                        S
                    </span>
                ))}
            </div>
        );
    };

    // render item
    const renderItem = (item, index) => {
        let indexForUpdate = Utils.findIndexInArrayById(item.id, itemList);
        return (
            <>
                <li>
                    <div className="createForm-info">
                        <div className="createForm-box">
                            <IconButton
                                aria-describedby={idNameStyle}
                                id={idNameStyle}
                                key={`color_${item.id}`}
                                style={{
                                    color: `${item.structure.helpdesk.color}`,
                                    background: `${item.structure.helpdesk.background}`
                                }}
                                data-cy="add-status-field-picker-color-helpdesk"
                                className="itemStatus"
                                onClick={event => {
                                    if (!isEditField(currentField, props)) {
                                        return;
                                    }
                                    setNameStylePopover(event.currentTarget);
                                    setUpdateStyleIndex(indexForUpdate);
                                }}
                            >
                                S
                            </IconButton>
                            <Popover
                                id={`${item.id}_more_action_id1`}
                                key={`${item.id}_more_action_key1`}
                                className="color-list-content"
                                open={isOpenNameStylePopover}
                                anchorEl={nameStylePopover}
                                onClose={e => setNameStylePopover(null)}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right'
                                }}
                                transformOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                }}
                            >
                                {!Utils.isEmptyArray(itemStatusColor) &&
                                    renderColorPicker('helpdesk')}
                            </Popover>
                        </div>
                        <div className="createForm-control">
                            <div className="createForm-field">
                                <TextField
                                    className="form-input-outlined"
                                    placeholder={tr('ステータス名')}
                                    data-cy="status-item-input-name"
                                    id={`${item.id}_textInputName_id`}
                                    key={`${item.id}_textInputName_key`}
                                    // autoFocus={
                                    //     Utils.isEmpty(item.isAutoFocusItemName)
                                    //         ? false
                                    //         : item.isAutoFocusItemName
                                    // }
                                    onChange={event =>
                                        onChangeItemName(event, indexForUpdate, argsAll)
                                    }
                                    defaultValue={Utils.getTextByLanguage(
                                        Constant.LANGUAGE_TYPE.JP,
                                        item.name
                                    )}
                                    onKeyPress={event =>
                                        onKeyPressItemName(event, indexForUpdate, argsAll)
                                    }
                                    onBlur={event =>
                                        onChangeItemName(event, indexForUpdate, argsAll)
                                    }
                                    // disabled={!isEditField(currentField, props)}
                                    disabled={true}
                                    error={item.errorMsg?.name ? true : false}
                                />
                                <div className="item-status">
                                    {/* <IconButton className="itemTools">
                                        <img src="/assets/image/icon-copy.svg" alt="" />
                                    </IconButton> */}

                                    {isAddNewItem(item, argsAll) && (
                                        <IconButton
                                            className="itemTools"
                                            onClick={e => removeItem(item, argsAll)}
                                        >
                                            <img src="/assets/image/icon-tabs-delete.svg" alt="" />
                                        </IconButton>
                                    )}
                                    {/* <IconButton className="itemTools">
                                        <img src="/assets/image/icon-pin.svg" alt="" />
                                    </IconButton> */}
                                </div>

                                {item.errorMsg?.name && (
                                    <>
                                        <span className="message-error">{item.errorMsg?.name}</span>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="createForm-info">
                        <div className="createForm-box">
                            <IconButton
                                className="itemStatus"
                                aria-describedby={idCustomerNameStyle}
                                id={idCustomerNameStyle}
                                key={`customer_color_${item.id}`}
                                style={{
                                    color: `${item.structure.customer.color}`,
                                    background: `${item.structure.customer.background}`
                                }}
                                onClick={event => {
                                    if (!isEditField(currentField, props)) {
                                        return;
                                    }
                                    setCustomerNameStylePopover(event.currentTarget);
                                    setUpdateStyleIndex(indexForUpdate);
                                }}
                                data-cy="add-status-field-picker-color-customer"
                            >
                                S
                            </IconButton>
                            <Popover
                                id={idCustomerNameStyle}
                                className="color-list-content"
                                open={isOpenCustomerNameStylePopover}
                                anchorEl={customerNameStylePopover}
                                onClose={e => setCustomerNameStylePopover(null)}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right'
                                }}
                                transformOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                }}
                            >
                                {!Utils.isEmptyArray(itemStatusColor) &&
                                    renderColorPicker('customer')}
                            </Popover>
                        </div>
                        <div className="createForm-control">
                            <div className="customerStatus">
                                <p className="customerStatus-text">{tr('カスタマー用ステータス')}</p>
                                <div className="customerStatus-control">
                                    <TextField
                                        className="form-control-wrapInput form-control-hg32"
                                        variant="outlined"
                                        data-cy="status-item-input-info"
                                        id={`textInputShortName_${item.id}_id`}
                                        key={`textInputShortName_${item.id}_key`}
                                        placeholder=""
                                        onChange={event =>
                                            onChangeCustomerView(event, indexForUpdate, argsAll)
                                        }
                                        defaultValue={Utils.getTextByLanguage(
                                            Constant.LANGUAGE_TYPE.JP,
                                            item.viewForCustomer
                                        )}
                                        onBlur={event =>
                                            onChangeCustomerView(event, indexForUpdate, argsAll)
                                        }
                                        disabled={!isEditField(currentField, props)}
                                        error={item.errorMsg?.viewForCustomer}
                                        helperText={item.errorMsg?.viewForCustomer}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </>
        );
    };

    return (
        <div className="groupManage">
            <div className="headManage">
                <div className="headManage-top">
                    <h2 className="headManage-title">{tr('ステータス編集')}</h2>
                    <div className="headManage-tools">
                        <div className="headManage-btn">
                            <Button
                                className="btn-light btn-hg32"
                                data-cy="add-status-item-btn-cancel"
                                variant="contained"
                                color="default"
                                onClick={event => onCancelSaveItemList(argsAll, props)}
                            >
                                {tr('閉じる')}
                            </Button>
                            <Button
                                className="btn-primary btn-hg32"
                                data-cy="add-status-item-btn-submit"
                                variant="contained"
                                color="primary"
                                onClick={event => onSubmitSaveItemList(argsAll, props)}
                                disabled={isDisableBtnSave}
                            >
                                {tr('保存')}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            {/* headManage */}
            <div className="contentManage">
                <div
                    className={
                        !useButtonCollapse ? 'accordionForm accordionForm--show' : 'accordionForm'
                    }
                >
                    {/* Khi click vào 'div accordionHead' thì 'div accordionForm sẽ add accordionForm--show' */}
                    <div className="accordionHead" onClick={hanldeUseButtonCollapse}>
                        <span className="accordionHead-item">
                            <img src="/assets/image/icon-pin.svg" alt="" />
                        </span>
                        <span className="accordionHead-text">
                            {tr('以下のステータスは使用する')} ({itemUsingList.length})
                        </span>
                    </div>
                    <div className="accordionContent">
                        <div className="createForm-status">
                            <ul>
                                {itemUsingList.map((item, index) => (
                                    <div key={item.id || index}>{renderItem(item, index)}</div>
                                ))}
                            </ul>
                        </div>
                        {/* createForm-status */}
                    </div>
                </div>
                {/* accordionForm */}
                <div
                    className={
                        !unUseButtonCollapse ? 'accordionForm accordionForm--show' : 'accordionForm'
                    }
                >
                    {/* Khi click vào 'div accordionHead' thì 'div accordionForm sẽ add accordionForm--show' */}
                    <div className="accordionHead" onClick={hanldeUnUseButtonCollapse}>
                        <span className="accordionHead-item">
                            <img src="/assets/image/icon-pin-outline.svg" alt="" />
                        </span>
                        <span className="accordionHead-text">
                            {tr('以下のステータスは使用しない')} ({itemNotUsingList.length})
                        </span>
                    </div>
                    <div className="accordionContent">
                        <div className="createForm-status">
                            <ul></ul>
                        </div>
                        {/* createForm-status */}
                    </div>
                </div>
                {/* accordionForm */}
            </div>
            {/* contentManage */}

            {/* confirm dialog */}
            <UnsavedChangesDialog
                isOpen={props?.isOpenUnsavedChangesDialog}
                messageConfirm={
                    formPanelTabClose.isClosePanel
                        ? trI18n('MSG-CONFIRM-CLOSE-PANEL')
                        : trI18n('MSG-CM-CONFIRM-CANCEL-FORM-FIELD-CHANGE')
                }
                closeCallBack={() => {
                    props?.setIsOpenUnsavedChangesDialog(false);
                    setFormPanelTabClose(prev => {
                        let isDirty = false;
                        const currentUpdateField = props.currentUpdateField;
                        if (!Utils.isEmptyObject(currentUpdateField)) {
                            // if createNew, not update isDirty = false
                            isDirty = currentUpdateField?.id?.includes('dummy');
                        }
                        return ({
                            isDirty: isDirty,
                            isClosePanel: false,
                            isCloseScreen: false
                        })
                    });
                    if (formPanelTabClose.isClosePanel) {
                        closePanelFormManagement({panelList, setPanelList, currentIndex, setCurrentIndex});
                        return;
                    }
                    if (formPanelTabClose.isCloseScreen) {
                        // Close button: back to parent screen
                        props.setPanelScreen(props.parentPanelScreen);
                        return;
                    }
                    // Tab switch
                    const preSelectedTab = props?.tabSelected;
                    props?.setTabSelected(preSelectedTab === Constant.TAB_FORM_MANAGEMENT.FIELD
                        ? Constant.TAB_FORM_MANAGEMENT.FORM
                        : Constant.TAB_FORM_MANAGEMENT.FIELD
                    );
                }}
                closeBtnText={trI18n('OK')}
                cancelCallBack={() => {
                    props?.setIsOpenUnsavedChangesDialog(false);
                    setFormPanelTabClose(prev => ({
                        ...prev,
                        isClosePanel: false,
                        isCloseScreen: false,
                    }));
                }}
                cancelBtnText={trI18n('CANCEL')}
            />
        </div>
    );
}
